export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--7.5928e869.png";